import './S_PaginationSelect.scss';
import { Option, Select } from '@mui/joy';
import { ReactElement } from 'react';

interface IProps {
  selected: number;
  options: number[];
  onChange: (selected: number) => Promise<void>;
}

export const S_PaginationSelect = ({ selected, options, onChange }: IProps): ReactElement => {
  return (
    <Select
      size='sm'
      value={selected}
      onChange={(_, v) => {
        void onChange(v ?? 0);
      }}
      className='pagination-select'
    >
      {options.map((r) => (
        <Option
          value={r}
          key={r}
        >
          {r}
        </Option>
      ))}
    </Select>
  );
};
